import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Table, Input, Button, Space, Tooltip, InputNumber, Form, Typography, Popconfirm } from 'antd';
import Highlighter from 'react-highlight-words';
import { SearchOutlined, LoadingOutlined } from '@ant-design/icons';

export default function NetTable({ data, loading}) {

    var searchInput;

    const [state, setState] = useState({
        searchText: '',
        searchedColumn: '',
    });

    const getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        // size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => handleReset(clearFilters)} style={{ width: 90 }}>
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => searchInput.select(), 100);
            }
        },
        render: text =>
            state.searchedColumn === dataIndex ? (
                <Tooltip placement="topLeft" title={
                    <Highlighter
                        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                        searchWords={[state.searchText]}
                        autoEscape
                        textToHighlight={text ? text.toString() : ''}
                    />
                }>
                    <Highlighter
                        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                        searchWords={[state.searchText]}
                        autoEscape
                        textToHighlight={text ? text.toString() : ''}
                    />
                </Tooltip>
            ) : (
                <Tooltip placement="topLeft" title={text}>{text}</Tooltip>
            ),
    });

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    const handleReset = clearFilters => {
        clearFilters();
        setState({ searchText: '' });
    };

    const columns = [
        {
            title: 'Substance(ID)',
            dataIndex: 'substance(ID)',
            key: 'substance(ID)',
            width: 150,
            editable: false,
            sorter: (a, b) => a["substance(ID)"].localeCompare(b["substance(ID)"]),
            ellipsis: {
                showTitle: false,
            },
            ...getColumnSearchProps('substance(ID)'),
        },
        {
            title: 'Substance(Name)',
            dataIndex: 'substance(Name)',
            key: 'substance(Name)',
            width: 150,
            editable: false,
            sorter: (a, b) => a["substance(Name)"].localeCompare(b["substance(Name)"]),
            ellipsis: {
                showTitle: false,
            },
            ...getColumnSearchProps('substance(Name)'),
        },
        {
            title: 'Formula',
            dataIndex: 'formula',
            key: 'formula',
            width: 150,
            editable: false,
            sorter: (a, b) => a["formula"].localeCompare(b["formula"]),
            ellipsis: {
                showTitle: false,
            },
            ...getColumnSearchProps('formula'),
        },
        {
            title: 'Objective Value',
            dataIndex: 'objective_value',
            key: 'objective_value',
            width: 150,
            editable: false,
            sorter: (a, b) => a["objective_value"] - b["objective_value"],
            ellipsis: {
                showTitle: false,
            },
            ...getColumnSearchProps('objective_value'),
        }
    ];

    return (
        <Table
            id="antdTable"
            rowKey="substance(ID)"
            columns={columns}
            dataSource={data}
            loading={loading}
            pagination={data.length > 10 ? true : false}
            // scroll={{ x: 1050 }}
        />

    );
    // }
}
